import React, { Children, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import keys from 'lodash/keys';
import debounce from 'lodash/debounce';

import { match as backendMatch } from 'css-mediaquery';
import { breakpoints } from './breakpoints';
import { bugsnagLeaveBreadcrumb } from '../../util/bugsnag';
import { MediaContextProvider } from './context';

const breakpointsKeys = keys(breakpoints);
const match = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia : backendMatch;

const MediaProvider = (props) => {
  const [, update] = useState({});

  const matched = breakpointsKeys.reduce(
    (currentResult, key) => ({
      ...currentResult,
      [key]: match(breakpoints[key], props.deviceInfo).matches,
    }),
    {},
  );

  useEffect(() => {
    const handleResize = debounce(() => {
      const { innerWidth, innerHeight } = window;
      bugsnagLeaveBreadcrumb('window resize', { innerWidth, innerHeight });
      update({});
    }, 64);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <MediaContextProvider value={{ media: matched }}>
      {Children.only(props.children)}
    </MediaContextProvider>
  );
};

MediaProvider.propTypes = {
  children: PropTypes.node.isRequired,
  deviceInfo: PropTypes.shape({
    type: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
  }),
};

MediaProvider.defaultProps = {
  deviceInfo: {
    type: 'screen',
    height: '1366px',
    width: '768px',
  },
};

export default MediaProvider;
